<template>
    <div>
        <div>
            <el-row>
                <h1 class="project_head_title">通报</h1>
                <el-divider class="divider" />
            </el-row>
            <el-form label-width="120px">
                <el-divider class="divider" />

                <el-row class="form-row">
                    <el-col :span="7">
                        <el-form-item label="标题" prop="labelValue">
                            <el-input v-model="queryForm.title" placeholder="模糊搜索"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="内容" prop="labelValue">
                            <el-input v-model="queryForm.content" placeholder="模糊搜索"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item>
                            <el-button :disabled="loading" type="primary" icon="el-icon-search" @click="currentPage=1;getDataList()">搜索</el-button>
                            <el-button type="primary" icon="el-icon-download" @click="showDialog()">新增</el-button>
                            <el-button type="primary" @click="getDataList(true)">导出</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div v-loading="loading">
                <el-table class="tb-mini" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" border :data="datas" @selection-change="handleSelectionChange" align="center">
                    <el-table-column label="序号" type="index" width="70" align="center">
                        <template scope="scope">
                            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                        </template>
                    </el-table-column>
                <el-table-column prop="title" label="标题" show-overflow-tooltip min-width="100px"></el-table-column>
                <el-table-column prop="content" label="内容" show-overflow-tooltip min-width="300px"></el-table-column>
                <el-table-column prop="readNum" label="阅读数量" show-overflow-tooltip width="150px"></el-table-column>
                <el-table-column prop="creatorStr" label="创建人" show-overflow-tooltip min-width="150px"></el-table-column>
                <el-table-column prop="createdStr" label="创建日期" show-overflow-tooltip min-width="150px"></el-table-column>
                <el-table-column prop="changeorStr" label="最后修改人" show-overflow-tooltip min-width="150px"></el-table-column>
                <el-table-column prop="changedStr" label="最后修改日期" show-overflow-tooltip min-width="150px"></el-table-column>
                <el-table-column  label="操作" width="180px" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" @click="showDialog(scope.row.guid)">修改</el-button>
                            <el-button type="text" @click="showDialog(scope.row.guid,true)">详情</el-button>
                            <el-button type="text" @click="deleteById(scope.row.guid)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[15, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    style="text-align:right"
                ></el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" :title="detail?'详情':(dataForm.guid?'修改':'新增')" width="60%">
            <el-form label-width="120px" :rules="rules" ref="form" :model="dataForm" :disabled="detail" style="padding-right:100px;">
                <el-form-item label="标题" prop="title">
                <el-input v-model="dataForm.title" placeholder="" clearable/>
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <el-input type="textarea"
                  :rows="10"
                  maxlength="1000" show-word-limit v-model="dataForm.content" placeholder="" clearable/>
            </el-form-item>
            <el-tooltip content="首页只会展示第一张图片" placement="top" effect="light">
                <el-form-item label="展示图片" prop="" style="text-align: left;">
                    <!-- <FieldUpload label="" :disabled="detail" type="IMG" :fileIds="imgListIds" @fileChange="imgListIds=$event" @imgView="dialogVisible=!$event"></FieldUpload> -->
                    <FieldUpload label="" :disabled="detail" type="IMG" :fileIds="imgListIds" @fileChange="imgListIds=$event"></FieldUpload>
                </el-form-item>
            </el-tooltip>
            <el-form-item label="附件" prop="" style="text-align: left;">
                <Upload :disabled="detail" :fileIds="fileListIds" @getUploadFileIds="getUploadFileIds"></Upload>
            </el-form-item>
        </el-form>
            <span v-if="!detail" slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save()">保 存</el-button>
            </span>
            <span v-else slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return {
            fileListIds:[],
            imgListIds:[],
            detail:false,
            queryForm:{
            },
            currentPage:1,
            pageSize:15,
            total: 0,
            datas: [],
            loading:false,
            dialogVisible:false,
            dataForm:{},
            rules:{
                title:{required:true,message:'请填写数据',trigger:'blur'},
                content:{required:true,message:'请填写数据',trigger:'blur'},
            },
            
            col:[['标题','title'],['内容','content'],['阅读数量','readNum']]
        }
    },
    mounted(){
        this.getDataList()
    },
    methods:{
        showDialog(id,detail = false){
            this.detail = detail
            this.dialogVisible = true
            this.dataForm = {}
            this.fileListIds = []
            this.imgListIds = []
            if(this.$refs['person']){
                this.$refs['person'].clearSelection()
            }
            if(this.$refs['form']){
                this.$refs['form'].resetFields()
            }
            
            if(id){
                this.$http.get('/api/ts/v0.1/article/'+id)
                .then(res=>{
                    this.dataForm = res.data
                    if(this.dataForm.imgs){
                        this.imgListIds = this.dataForm.imgs.split(',')
                    }
                    if(this.dataForm.files){
                        this.fileListIds = this.dataForm.files.split(',')
                    }
                    console.log(this.dataForm)
                })
            }
        },
        deleteById(id){
            this.$confirm('此操作将永久删除该数据，是否继续？','提示'
                ,{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(()=>{
                    this.$http.delete('/api/ts/v0.1/article/'+id).then(res=>{
                if (res.data >= 1) {
                    this.getDataList()
                    this.$message.success('操作成功')
                } else {
                    this.$message.error('操作失败')
                }
            }).catch((err)=>{
                this.$message.error('操作失败')
            })
                })
            
        },
        save(){
            console.log(this.dataForm,'1111111')
            this.$refs['form'].validate((valid)=>{
                if(valid){
                    this.dataForm.imgs = this.imgListIds.join(',')
                    this.$http.post('/api/ts/v0.1/article/save',this.dataForm)
                    .then(res=>{
                        if (res.data >= 1) {
                            this.getDataList()
                            this.dialogVisible = false
                            this.$message.success('操作成功')
                        } else {
                            this.$message.error('操作失败')
                        }
                    })
                    .catch((err)=>{
                        this.$message.error('操作失败')
                    })
                }else{
                    this.$message.error('请填写数据')
                }
            })
            
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getDataList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getDataList()
        },
        getDataList(isExport = false){
            if(isExport){
                this.queryForm.pageSize = 10000000
                this.queryForm.pageNum = 1
                this.exportDatas = []
            }else{
                this.queryForm.pageSize = this.pageSize
                this.queryForm.pageNum = this.currentPage
                this.datas = []
            }
            
            this.$http.get('/api/ts/v0.1/article/page',{params:{...this.queryForm}})
            .then(res=>{
                if(res.status==200){
                    if(isExport){
                        this.$onExport(res.data.list,this.col,"在线举报通报")
                    }else{
                        this.datas = res.data.list
                        this.total = res.data.total
                    }
                }else{
                    this.$message.error('查询失败！请联系管理员')
                }
                
                this.loading=false;
            })
            .catch((err)=>{
                this.loading=false;
            })
        },
        getUploadFileIds(files){
            this.dataForm.files = files.join(',')
        }
    }
}
</script>

<style scoped>
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 100%;
    }
    .el-select{
        width:100%;
    }
    .el-input-number{
        width: 100%;
    }
</style>